export async function subscribeToBackInStock({
  variantId,
  companyId,
  email,
}: {
  variantId: string;
  companyId: string;
  email?: string;
}): Promise<any> {
  const options: RequestInit = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2023-09-15",
      "content-type": "application/json",
      "Access-Control-Allow-Headers": "*",
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }),
  };

  try {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`,
      options,
    );

    if (response.status == 202 || response.status == 200) {
      return response;
    }

    const { errors } = await response.json();

    const error = errors[0];

    return error;
  } catch {
    throw Error("Something went wrong");
  }
}

export default (variantId: string, companyId: string) => ({
  email: "",
  success: false,
  error: null,
  loading: false,
  invalid: false,
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  async submit() {
    if (!this.email) {
      return (this.invalid = true);
    }

    if (!this.validateEmail(this.email)) {
      return (this.invalid = true);
    } else {
      this.invalid = false;
    }

    if (!variantId) {
      this.error = "Missing Variant ID";
      return;
    }

    this.loading = true;

    try {
      const response: Response = await subscribeToBackInStock({
        variantId,
        email: this.email,
        companyId,
      });

      if (response.status == 202 || response.status == 200) {
        this.success = true;
      } else if (response.errors[0].code === "invalid") {
        this.invalid = true;
      } else {
        this.error = response.errors ? response.errors[0] : "Unknown error";
      }
    } catch (error) {
      this.error = "Something went wrong";
      throw error;
    } finally {
      this.invalid = false;
      this.loading = false;
    }
  },
});
